"use client";

import ReviewsErrorBoundary from "../../src/app/reviews/error";

export default ReviewsErrorBoundary;
